import WsService from "../../WsService";
import InboundPaymentRequest from "../../../domain/Transaction/inbound/InboundPaymentRequest";

const ENDPOINT_BASE = "/transactions/inbound/payment"

export default class InboundPaymentService {

  static retrieveByTransactionId(inboundTransactionId) {

    let endpoint = ENDPOINT_BASE + "?inbound-transaction-id=" + inboundTransactionId;

    return WsService.get(endpoint, {}, 200).then(
      response => {
        return new InboundPaymentRequest(response)
      },
      response => {
        return response;
      }
    );
  }
}
